export default "__VITE_ASSET__BS3m01m9__"